<template>
  <div id="Contact">
    <Header/>
    <div class="breadcrumb-bg">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item><router-link class="link-back" to="/">首頁</router-link></el-breadcrumb-item>
        <el-breadcrumb-item class="current">聯繫我們</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="con animated bounceInDown">
      <div class="title-top">
        <div class="label">
          <span>
            <i class="iconfont">&#xe737;</i>
            <em>聯繫我們</em>
          </span>
        </div>
        <p>請提供以下個人資料，我們的專業團隊將與你聯繫並提供更詳盡的資訊。</p>
      </div>
      <div class="form-bottom">
        <el-form ref="form" :model="form" :rules="rules" >
          <el-form-item class="v1" prop="searchType">
            <el-select class="v-select" v-model="form.searchType" placeholder="查詢類別*" @change="selectCarMode(form.searchType)">
              <el-option v-for="item in tableType" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <div class="v1" v-if="!on"></div>
          <el-form-item class="v1" prop="carModel" v-if="on">
            <el-select class="v-select" v-model="form.carModel" placeholder="車型*" ref="model">
              <el-option v-for="item in tableCar" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="v2" >
            <el-select v-model="form.appellation" placeholder="稱謂">
              <el-option label="先生 " value="先生"></el-option>
              <el-option label="女士 " value="女士"></el-option>
              <el-option label="太太" value="太太"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="v2" prop="name">
            <el-input placeholder="名字*" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item class="v2" prop="surname">
            <el-input placeholder="姓名*" v-model="form.surname"></el-input>
          </el-form-item>
          <el-form-item class="v2" prop="phone">
            <el-input placeholder="電話*" v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item class="v2" prop="email" >
            <el-input placeholder="電郵" v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item class="v3">
            <el-input type="textarea" placeholder="請在此寫下您的留言" v-model="form.message"></el-input>
          </el-form-item>
          <p>*必填欄目</p>
          <p>
            <label>
            <el-checkbox :class="{'borderColor': form.yesno == false ? true : false}" name="type" v-model="form.yesno"></el-checkbox>
            <span :style="{color: form.yesno == true ? '#000' : form.yesno == false ? '#f41c1c' : ''}">
            本人同意在本表格上所提供的個人資料，將會由 IVECO 香港及澳門 - Star Auto Holding Ltd.，錦龍汽車集團 (下稱本公司) 擁有，並授權本公司對閣下發出直接推廣通訊。</span>
            </label>
          </p>
          <el-form-item class="v4">
            <el-button type="primary" @click="submitForm('form')">提交 ></el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '../components/Header.vue'      //公共头部
import Footer from '../components/Footer.vue'      //底部
import { reqAddContactUsInfo } from '../untils/api.js'
import Format from '../components/Format.js'


export default {
  name: 'Contact',
  data () {
    return {
      on: false,
      tableType: [
        { id: 1, name: '新車查詢' },
        { id: 2, name: '售後查詢' },
        { id: 3, name: '其他' },
      ],
      tableCar: [
        { id: 1, name: '全新DAILY貨VAN王' },
        { id: 2, name: '全新DAILY CAB車陣王' },
        { id: 3, name: 'EUROCARGO' },
        { id: 4, name: '其他車型' },
      ],
      form: {
        searchType: '',  //查询类别
        carModel: '',    //车型
        appellation: '', //称谓
        name: '',        //名字
        surname: '',    //姓氏
        phone: '',      //电话
        email: '',     //电邮
        message: '',    //留言
        yesno: null
      },
      rules: {
        searchType: [
          { required: true, message: '請選擇查詢類別', trigger: 'change' }
        ],
        carModel: [
          { required: true, message: '請選擇車型', trigger: 'change' }
        ],
        name: [
          { required: true, message: '請填寫名字', trigger: 'blur' }
        ],
        surname: [
          { required: true, message: '請填寫姓名', trigger: 'blur' }
        ],
        phone: [
          {
            validator: Format.FormValidate.Form().phone,
            trigger: "blur"
          }
        ],
        email: [
          {
            validator: Format.FormValidate.Form().email,
            trigger: "blur"
          }
        ],
      }
    }
  },
  methods: {
    selectCarMode(rowId) {
      console.log('this', this)
      console.log('rowId', rowId)
      this.form.type = rowId
      if (rowId == 1 || rowId == 2) {
        this.on = true
      } else {
        this.on = false
      }
    },
    submitForm(form) {
      console.log('that.form.searchType',this.form.searchType)
      let that = this
      that.$refs[form].validate((valid) => {
        if (that.form.yesno == null || that.form.yesno == false) {
          that.form.yesno = false
          return false
        }
        if (valid) {
          let formData = {
            searchType: that.tableType[that.form.searchType-1].name,
            carModel: that.form.searchType == 3 ? ' ' : that.tableCar[that.form.carModel-1].name,
            appellation: that.form.appellation,
            name: that.form.name,
            surname: that.form.surname,
            phone: that.form.phone,
            email: that.form.email,
            message: that.form.message
          }
          reqAddContactUsInfo(formData).then(res => {
            if (res.code == 200)
              // that.$message({
              //   message: "提交成功！",
              //   customClass: 'mode',
              //   type: 'success'
              // })
              setTimeout(() => {
                this.$confirm('感謝您！您的查詢已經提交，我們的專員會盡快聯絡您。', {
                  confirmButtonText: '確定',
                  showCancelButton: false,
                  distinguishCancelAndClose: true,
                  center: true
                })
                that.$refs['form'].resetFields()
                that.form.carModel = ''
                that.form.appellation = ''
                that.form.message = ''
                that.form.yesno = null
                that.on = false
              }, 200)
              // console.log('formformformform',that.form)
          })
        } else {
          // console.log('error submit!!');
          return false;
        }
      })
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style>
  .el-input__inner::input-placeholder,
  .el-textarea__inner::input-placeholder {
    color: #999 !important;
  }
  .el-input__inner::-webkit-input-placeholder,
  .el-textarea__inner::-webkit-input-placeholder {
    color: #999 !important;
  }
  /* input:-moz-placeholder, */
  /* textarea:-moz-placeholder, */
  /* input::-moz-placeholder, */
  /* textarea::-moz-placeholder, */
  /* input [type=text]:-moz-placeholder, */
  /* input [type=text]::-moz-placeholder, */
  .el-input__inner:-moz-placeholder,
  .el-input__inner::-moz-placeholder,
  .el-textarea__inner:-moz-placeholder,
  .el-textarea__inner::-moz-placeholder {
    color: #999 !important;
    opacity: 1 !important;
  }
  .el-input__inner:-ms-input-placeholder,
  .el-input__inner::-ms-input-placeholder,
  .el-textarea__inner:-ms-input-placeholder,
  .el-textarea__inner::-ms-input-placeholder {
    color: #999 !important;
  }

  .el-input__inner,
  .el-textarea__inner {
    color: #000 !important;
  }
  .el-textarea__inner {
    font-family: "Microsoft YaHei", "Arial", Helvetica, sans-serif;
  }
  .el-message-box {
    width: 258px !important;
  }
  .el-message-box .el-message-box__content{
    text-align: center !important;
  }
  .el-message-box .el-message-box__btns {
    text-align: center !important;
  }
  .el-button--primary {
    background-color: #333 !important;
    border-color: #333 !important;
  }
  .el-button--primary:focus {
    background-color: #333 !important;
    border-color: #333 !important;
  }
  .el-button--primary:hover {
    background-color: #333 !important;
    border-color: #333 !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #222 !important;
    border-color: #222 !important;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #222 !important;
  }
  .el-checkbox__inner:hover {
    border-color:#222 !important;
  }
  .borderColor .el-checkbox__inner {
    border-color: #f41c1c !important;
  }
  .borderColor .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #f41c1c !important;
  }
  .el-checkbox__inner:hover {
    border-color:#f41c1c !important;
  }

  .el-input,
  .el-textarea {
    font-size: 12px !important;
  }

  @media (min-width: 468px) {
    .el-input,
    .el-textarea {
      font-size: 14px !important;
    }
  }
</style>


<style lang="stylus" ref="stylesheet/stylus" scoped>

  #Contact {
    background: #f4f4f4;
    position: relative;
    max-width: 1440px;
    margin: 0 auto;
    box-shadow: 0 0 16px #a6a6a6;
    .breadcrumb-bg {
      margin-top: 50px;
      text-transform: uppercase;
      // margin-top: 50px;
      box-shadow: 0 3px 2px rgba(0,0,0,0.1);
      background: #f3f3f3;
      .breadcrumb {
        padding: 10px 10px 6px !important;
      }
      .el-breadcrumb {
        font-size: 13px;
        line-height: 16px;
        padding: 10px 0;
        background: #f3f3f3;
        span {
          padding-bottom: 3px;
          &:last-of-type {
            width: 170px;
            display: inline-block;
            white-space: nowrap; 
            overflow: hidden;
            text-overflow:ellipsis;
          }
        }
      }
    }
    .con {
      width: auto;
      margin-top: 20px;
      padding-bottom: 20px;
      // background: #eeeeee;
      background: #f3f3f3;
      // box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      // -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      .title-top {
        width: 100%;
        margin: 0 auto;
        padding: 45px 0 10px;
        background: #fff;
        height: auto;
        position: relative;
        z-index: 1;
        background-color: #FFFFFF;
        color: #545454;
        .label {
          // background-image: url(../images/box-label-corner.png);
          background-position: 0 0;
          background-repeat: no-repeat;
          left: -7px;
          padding-left: 0;
          padding-top: 5px;
          position: absolute;
          z-index: 5;
          max-width: 100%;
          top: 16px;
          &::before {
            content: '';
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 0 5px 7px;
            border-color: transparent transparent #666 transparent;
            position: absolute;
            top: -5px;
            left: 0;
          }
          span {
            z-index: 100;
            position: absolute;
            top: 0;
            background-color: #000000;
            color: #EBEBEB;
            height: 26px;
            line-height: 15px;
            /* max-width: 90%; */
            overflow: hidden;
            padding: 5px 10px 5px 10px;
            text-overflow: ellipsis;
            text-transform: uppercase;
            white-space: nowrap;
            display: block;
            border-radius: 0px;
            em {
              font-weight: 700;
              font-size: 13px;
              font-style: normal;
            }
          }
        }
        p {
          font-size: 14px;
          padding: 25px 0 10px 0;
          margin: 0 20px 0 18px;
          border-bottom: 1px solid #666;
        }
      }
      .form-bottom {
        font-size: 13px;
        width: 100%;
        margin: 0 auto;
        background: #fff;
        form {
          width: 94%;
          padding: 20px 0;
          margin: 0 auto;
          .v1 {
            font-size: 12px;
            width: 45%;
            padding: 0 0 10px;
            margin-bottom: 20px;
            margin-right: 1.5%;
            display: inline-block;
            .v-select {
              width: 100%;
            }
          }
          .v2 {
            width: 49.25%;
            margin-bottom: 30px;
            float: left;
            box-sizing: border-box;
            box-sizing: content-box;
            &:nth-of-type(3) {
              width: 24%;
              margin-right: 1.5%;
            }
            &:nth-of-type(4),
            &:nth-of-type(5) {
              width: 36.5%;
              margin-right: 1.5%;
            }
            &:nth-of-type(5) {
              margin-right: 0; 
            }
            &:nth-of-type(6) {
              margin-right: 1.5%; 
            }
          }
          .v3 {
            width: 100%;
            float: left;
          }
          p {
            width: 100%;
            margin: 20px 0;
            overflow hidden;
          }
          
          label,
          span {
            margin: 0;
            display: block;
            float: left;
          }
          span {
            width: 90%;
            margin-left: 6px;
            cursor: pointer;
          }
          .v4 {
            padding-top: 30px;
            text-align: right;
          }
          button {
            width: 120px;
            background-color: #222;
            border-color: #222;
            border-radius: 0;
            padding: 12px 14px;
            &:hover {
              background-color: #111;
              border-color: #111;
            }
          }
        }
      }
    }
  }
  @media (min-width: 468px) {
    #Contact {
      .con {
        .title-top {
          p {
            margin: 0 28px 0 26px;
          }
        }
        .form-bottom {
          form {
            width: 80%;
            .v1 {
              width: 40%;
              .v-select {
                width: 100%;
              }
            }
            .v2 {
              &:nth-of-type(3) {
                width: 19%;
                margin-right: 1.5%;
              }
              &:nth-of-type(4),
              &:nth-of-type(5) {
                width: 39%;
                margin-right: 1.5%; 
              }
              &:nth-of-type(5) {
                margin-right: 0; 
              }
              &:nth-of-type(6) {
                margin-right: 1.5%; 
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 768px) {
    #Contact {
      .breadcrumb-bg {
        margin-top: 50px;
      }
      .con {
        .form-bottom {
          form {
            .v1 {
              margin-bottom: 14px;
              .v-select {
              }
            }
            .v2 {
              margin-bottom: 20px;
            }
          }
        }
      }
    }
  }
  
  @media (min-width: 992px) {
    #Contact {
      .breadcrumb-bg {
        margin-top: 0;
      }
      .con {
        width: 100%;
        .title-top {
          width: 990px;
        }
        .form-bottom {
          width: 990px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue